import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

/*
 * AH Prijsfavorieten — two parts of three weekly rotations each: Deel 1
 * (24 aug – 13 sep 2026, wk35–37, finished) and Deel 2 (28 sep – 18 okt 2026,
 * wk40–42). The payload carries Deel 2 with a frozen copy of Deel 1 as
 * `previous`, and the page compares the two. A live AH campaign, separate from
 * the frozen AH game-app dashboard.
 * Its own payload shape and page (features/prijsfavorieten), so
 * `kind: 'prijsfavorieten'`.
 *
 * The design's hero reads "24 aug → 6 sep", which is week 2's end rather than
 * the campaign's; the spec and the design's own week strip (wk 3 = 7–13 sep)
 * both give 13 sep, and that is what the pipeline emits.
 *
 * The pipeline now exists; when it has no payload yet the page falls back to
 * PF_EMPTY (zeros) with its "Geen live data" pill — never invented figures.
 */
export const ahPrijsfavorietenConfig: DashboardConfig = {
  path: '/ah/prijsfavorieten',
  reportId: 'ah-prijsfavorieten',
  label: 'AH Prijsfavorieten',
  endsOn: '2026-10-18', // Deel 2, 28 Sep → 18 Oct — archived from the day after
  kind: 'prijsfavorieten',
  apiBaseUrl: clusterBase('eu'),
};
